export default "__VITE_ASSET__d23960a4__"